import { TourId } from 'webapp/enums/tour';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import type { TourReactStep } from 'webapp/models-custom/tour-react';
import TourReactBase from 'webapp/models-custom/tour-react';

export default class GenieClientSelectorTour extends TourReactBase {
	static keyForPersistantDone = UserSettingsKey.GENIE_CLIENT_SELECTOR;

	get id(): string {
		return TourId.GENIE_CLIENT_SELECTOR;
	}

	override get keyForPersistantDone(): string {
		return GenieClientSelectorTour.keyForPersistantDone;
	}

	get steps(): TourReactStep[] {
		return [
			{ id: 'client-selector', anchorId: 'client-selector', side: 'top', align: 'start' },
		];
	}
}
